module.exports = __webpack_public_path__ + "static/media/rubyhero.bba8d11b.jpg";